import { fetchForms } from './fetch-forms';
import { loadLocaleDataset, loadTranslations, } from '../../services/load-translations';
export const getInitialData = async ({ formIds, formKind, namespace, enableMultilineAddress, throwWhenFormMissing, useListInsteadQuery, locale, httpClient, errorMonitor, }) => {
    const [formsById, translations, tpaTranslations, localeDataset] = await Promise.all([
        fetchForms({
            formIds,
            formKind,
            namespace,
            httpClient,
            errorMonitor,
            throwWhenFormMissing,
            useListInsteadQuery,
        }),
        loadTranslations(locale),
        {},
        enableMultilineAddress ? loadLocaleDataset(locale) : {},
    ]);
    return { formsById, translations, tpaTranslations, localeDataset };
};
//# sourceMappingURL=get-initial-data.js.map